/**
 * @module utils/string
 * @category Utilidades
 * @summary Módulo de utilidades para manipulação de _strings_.
 *
 * @description
 * Expõe funções de utilidades para manipulação de _strings_.
 *
 * @requires module:utils/lang.isEmpty
 * @requires module:utils/lang.isString
 */

import { isEmpty, isString } from "../lang";

/**
 * Remove expaços em branco extras de um texto.
 * @function
 * @param {string} value - Texto a ter espaços em branco extras removidos.
 * @param {boolean} nullified[true] - Indica se `null` deve ser retornado caso o valor
 * final esteja vazio.
 * @returns {string}
 */
export const clear = function(value, nullified = true) {
  const cleared = !isString(value) || isEmpty(value) ? "" : value.trim();

  return nullified && !cleared ? null : cleared;
};

export default { clear };
